import React from "react";
import "./ImpersonatedAlert.scss";
import { SessionKeys } from "../utils/AppUtils";
import { getMyTeamListReq, impersonateUser, setUserRole } from "../redux/user/actions";
import { useDispatch, useSelector } from "react-redux";
import { useState, useEffect } from "react";
import { loginBrokerResponse } from "../redux/auth/actions";
import _ from "lodash";
import ConfirmModal from "./modal/ConfirmModal";
import Loader from "./Loader/Loader";
import { useNavigate } from "react-router-dom";
import { getActiveHeader } from "../redux/home/actions";

const ImpersonatedAlert = () => {
  const userName = localStorage.getItem(SessionKeys.FIRST_NAME)+" "+localStorage.getItem(SessionKeys.LAST_NAME);
  let dispatch = useDispatch();
  let navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);
  const [impersonateAPICalled, setimpersonateAPICalled] = useState(false);

  const impersonateRes = useSelector((state) => state.user.impersonateUserData);
  const [confirmModal, setConfirmModal] = useState(false);
  const [isConfirm, setIsConfirm] = useState(false);
  const [showModalMsg, setShowModalMsg] = useState("");

  const stopImpersonating = () => {
    setShowModalMsg(`Exit impersonation mode and return to your account?`);
    setIsConfirm(true);
    setConfirmModal(true);
  };

  useEffect(() => {
    if (!_.isEmpty(impersonateRes) && impersonateAPICalled) {
      console.log("check--", impersonateRes);
      if (impersonateRes?.status === "success") {
        let userData = impersonateRes?.payload?.payload?.user_data;
        localStorage.setItem(SessionKeys.IS_IMPERSONATED, false);
        localStorage.removeItem(SessionKeys.LOGGED_IN_USER_TOKEN);
        localStorage.removeItem(SessionKeys.LOGGED_IN_USER_ID);
        localStorage.setItem(
          SessionKeys.API_TOKEN_BROKER,
          impersonateRes?.payload?.payload?.token
        );
        localStorage.setItem(SessionKeys.USER_ID, userData?.user_id);
        localStorage.setItem(SessionKeys.FIRST_NAME, userData?.firstname);
        localStorage.setItem(SessionKeys.LAST_NAME, userData?.lastname);
        if (_.isArray( userData?.role)) {
          // console.log("USER ROLE", roleArray);

          if ( userData?.role.includes("customer")) {
            dispatch(setUserRole("customer"));
          } else if ( userData?.role.includes("realtor")) {
            dispatch(setUserRole("realtor"));
          } else if ( userData?.role.includes("manager")) {
            dispatch(setUserRole("manager"));
          } else if ( userData?.role.includes("pmpro_membership_manager")) {
            // console.log("USER ROLE PMPRO", roleArray);
            dispatch(setUserRole("broker"));
          } else if ( userData?.role.includes("instructor")) {
            dispatch(setUserRole("instructor"));
          } else if ( userData?.role.includes("host")) {
            dispatch(setUserRole("host"));
          } else if ( userData?.role.includes("broker_admin")) {
            dispatch(setUserRole("admin"));
          }
        } 
        dispatch(getActiveHeader(""));
        dispatch(
          loginBrokerResponse({
            payload: {
              user: {
                user_id: userData?.user_id,
                username: userData?.username,
                firstname: userData?.firstname,
                middlename: userData?.middlename,
                lastname: userData?.lastname,
                email: userData?.email,
                bot_token: userData?.bot_token,
                ai_roleplay_token: userData?.ai_roleplay_token,
                profile_img: userData?.profile_img,
                isProfileCompleted: userData?.isProfileCompleted,
                isOnboarding: userData?.isOnboarding,
                isPremium: userData?.isPremium,
                profile_img_check: userData?.profile_img_check,
                city: userData?.city,
                state: userData?.state,
                designation: userData?.designation,
                timezone: userData?.timezone,
                timezoneAbbr: userData?.timezoneAbbr,
                profile_complete: userData?.profile_complete,
                broker_id: userData?.broker_id,
                broker_name: userData?.broker_name,
                zoom_id: userData?.zoom_id,
                company_id: userData?.company_id,
                role: userData?.role,
                IsGuest: userData?.IsGuest,
                ip_address: userData?.ip_address,
                broker_of_records: userData?.broker_of_records,
                isagreed: userData?.isagreed,
                complete_tour: userData?.complete_tour,
                guest_end_date: userData?.guest_end_date,
                display_subscription_menu: userData?.display_subscription_menu,
                is_parent: userData?.is_parent,
                parent_name: userData?.parent_name,
                branding: userData?.branding,
                apply_theme: userData?.apply_theme,
                branding_primary_color_1: userData?.branding_primary_color_1,
                branding_primary_color_2: userData?.branding_primary_color_2,
                branding_company_logo: userData?.branding_company_logo,
                is_google_sso_enabled: userData?.is_google_sso_enabled,
                is_ms_sso_enabled: userData?.is_ms_sso_enabled,
                is_sso_enabled: userData?.is_sso_enabled,
                partner_menu: userData?.partner_menu,
                courseURL: userData?.courseURL,
              },
              apiToken: impersonateRes?.payload?.payload?.token,
            },
          })
        );

        navigate("/my-teamlist");
        setTimeout(() => {
          setIsLoading(false);
        }, 2000);
      } else {
      }
      setimpersonateAPICalled(false);
    }
  }, [impersonateRes]);

  //   useEffect(() => {

  //    if(isConfirm){
  //
  //    }
  //   }, [isConfirm]);

  const confirmAction = () => {
    setimpersonateAPICalled(true);
    setIsLoading(true);
    dispatch(
      impersonateUser({
        module: "impersonate-user",
        postData: {
          user_id: localStorage.getItem(SessionKeys.LOGGED_IN_USER_ID),
          token: localStorage.getItem(SessionKeys.LOGGED_IN_USER_TOKEN),
          action: "stop_imp"
        },
      })
    );
  };

  return (
    <>
      <Loader start={isLoading} />
      <div class="impersonate-focus-box">
        <div class="container">
          <div class="row">
            <div class="col-md-12 d-flex align-items-center gap-2 position-relative justify-content-between">
              <p>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="24"
                  height="24"
                  fill="rgba(45,45,45,1)"
                >
                  <path d="M11.9999 17C15.6623 17 18.8649 18.5751 20.607 20.9247L18.765 21.796C17.3473 20.1157 14.8473 19 11.9999 19C9.15248 19 6.65252 20.1157 5.23479 21.796L3.39355 20.9238C5.13576 18.5747 8.33796 17 11.9999 17ZM11.9999 2C14.7613 2 16.9999 4.23858 16.9999 7V10C16.9999 12.6888 14.8776 14.8818 12.2168 14.9954L11.9999 15C9.23847 15 6.9999 12.7614 6.9999 10V7C6.9999 4.31125 9.1222 2.11818 11.783 2.00462L11.9999 2ZM11.9999 4C10.4022 4 9.09623 5.24892 9.00499 6.82373L8.9999 7V10C8.9999 11.6569 10.343 13 11.9999 13C13.5976 13 14.9036 11.7511 14.9948 10.1763L14.9999 10V7C14.9999 5.34315 13.6567 4 11.9999 4Z"></path>
                </svg>
                Impersonation mode active: <strong>{userName}</strong>.
              </p>
              <button
                type="button"
                class="startcourse-btn cursor-pointer"
                onClick={() => stopImpersonating()}
              >
                Stop Impersonation
              </button>
            </div>
          </div>
        </div>
      </div>
      <ConfirmModal
        confirmModal={confirmModal}
        setConfirmModal={setConfirmModal}
        showModalMsg={showModalMsg}
        confirmAction={confirmAction}
        isConfirm={isConfirm}
        isRightIcon={true}
      />
    </>
  );
};

export default ImpersonatedAlert;
